import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { totalPay } from "../states/atoms/store";

export default function Table({ list, total }) {
  const [pay, setPay] = useRecoilState(totalPay);
  useEffect(() => {
    setPay(total);
  }, [total, setPay]);

  return (
    <>
      <div className="flex flex-col w-full px-2 sm:px-4 md:px-8">
        {/* Horizontal Table for larger screens */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full table-auto border border-black">
            <thead>
              <tr className="bg-gray-100 p-1">
                <th className="font-bold border border-black w-32 text-center">Référence</th>
                <th className="font-bold border border-black text-center">Désignation</th>
                <th className="font-bold border border-black w-24 text-center">Quantité</th>
                <th className="font-bold border border-black text-center">Prix Unitaire</th>
                <th className="font-bold border border-black text-center">Montant TTC</th>
              </tr>
            </thead>
            <tbody>
              {list.map(({ id, product, quantity, price, variante }) => (
                <tr key={id} className="h-10">
                  <td className="border border-black text-center">{variante.reference}</td>
                  <td className="border border-black text-center text-sm">{product?.name}</td>
                  <td className="border border-black text-center">{quantity}</td>
                  <td className="border border-black text-center">{price.toLocaleString("fr-FR")}.00 Da</td>
                  <td className="border border-black text-center">{(price * quantity).toLocaleString("fr-FR")}.00 Da</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Vertical Cards for smaller screens */}
        <div className="block sm:hidden">
          {list.map(({ id, product, quantity, price, variante }) => (
            <div key={id} className="border border-black mb-4 p-4">
              <div className="mb-2">
                <span className="font-bold">Référence: </span>{variante.reference}
              </div>
              <div className="mb-2">
                <span className="font-bold">Désignation: </span>{product?.name}
              </div>
              <div className="mb-2">
                <span className="font-bold">Quantité: </span>{quantity}
              </div>
              <div className="mb-2">
                <span className="font-bold">Prix Unitaire: </span>{price.toLocaleString("fr-FR")}.00 Da
              </div>
              <div className="mb-2">
                <span className="font-bold">Montant TTC: </span>{(price * quantity).toLocaleString("fr-FR")}.00 Da
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-between mt-4">
          <div>
            <div className="flex flex-col sm:flex-row">
              <p className="font-bold uppercase text-sm mr-2">
                Validité de l'offre :
              </p>
              <p className="font-semibold uppercase text-sm">
                10 jours.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row">
              <p className="font-bold uppercase text-sm mr-2">
                Délais de livraison :
              </p>
              <p className="font-semibold uppercase text-sm">
                3 jours après réception du bon d'enlèvement.
              </p>
            </div>
          </div>
          <div className="mt-4 sm:mt-0">
            <p className="font-bold uppercase text-sm">Tous les produits sont fabriqués en Algérie</p>
          </div>
        </div>
      </div>
    </>
  );
}
